import { isAxiosError } from 'axios';

import { api } from 'services/repositories/config/base-api';

import { logger } from 'adapters/Logger';

export interface SendDataToAnalyticsParams {
  type: string;
  url: string;
  email: string;
  source: string;
  seller: string;
  system: string;
  clientId: string;
}

export const sendDataToAnalytics = async (
  data: SendDataToAnalyticsParams
): Promise<void> => {
  try {
    await api.post('/api/v1/analytics', data);
  } catch (error) {
    const requestContext = {
      requestUrl: '/api/v1/analytics',
      requestMethod: 'post',
    };

    // Fire-and-forget beacon: when the request never got a response (browser
    // offline, navigation abort, content blocker) there is nothing to fix on
    // our side, so it must not open a Sentry issue. Elastic still gets it.
    if (isAxiosError(error) && !error.response) {
      logger.warning(error, undefined, requestContext);
      return;
    }

    logger.error(error as Error, undefined, {
      ...requestContext,
      statusCode: isAxiosError(error) ? error.response?.status : undefined,
    });
  }
};
